<template>
    <div>
        <DeleteItemModal ref="deleteModal"></DeleteItemModal>
        <RestoreItemModal ref="restoreModal"></RestoreItemModal>
        <AggridList ref="aggridlist"
                    :componentGridOptions="gridOptions"
                    :excelColumns='["id", "locality.name", "region.name"]'
                    :service="service"
                    :deleted_filter="can('deleted-locality-read')"
        >
            <template v-slot:buttons>
                <router-link
                    v-if="can('create-locality')"
                    :to="{name: 'locality-create'}" class="btn btn-sm btn-primary"><i
                    class="fas fa-plus-square"></i>
                    <span class="d-none d-sm-inline ml-1">
                        {{ trans("Create") }}
                    </span>
                </router-link>
            </template>
        </AggridList>
    </div>
</template>

<script>

import LocalityService from "../../services/LocalityService";
import IdCellRenderer from "../../aggrid/cells/IdCellRenderer";
import IdCellParams from "../../aggrid/cells/IdCellParams";
import CRUDCellRenderer from "../../aggrid/cells/CRUDCellRenderer";
import CRUDCellParams from "../../aggrid/cells/CRUDCellParams";

export default {
    props: ["region_id"],
    data() {
        LocalityService.addFilter("region_id", this.region_id ?? null);

        return {
            service: LocalityService,
            gridOptions: {
                columnDefs: [
                    {
                        ...IdCellParams, cellRendererParams: {
                            getRoute(id) {
                                return {
                                    name: "locality-detail",
                                    params: {id}
                                };
                            }
                        }
                    },
                    {
                        headerName: this.trans("locality.Name"), field: "locality.name", width: 400,
                        sort: "asc",
                        floatingFilter: true,
                        cellRenderer: (prop) => {
                            if (!prop.data.name) return null;
                            if (prop.data.deleted_at) {
                                return `<del>${prop.data.name}</del>`;
                            }
                            return prop.data.name;
                        },
                        valueGetter(prop) {
                            return prop.data.name ? prop.data.name : null;
                        }
                    },
                    {
                        headerName: this.trans("locality.Region"), field: "region.name", width: 400,
                        floatingFilter: true,
                        suppressMenu: true,
                        floatingFilterComponentParams: {
                            suppressFilterButton: true,
                        },
                        cellRenderer: (prop) => {
                            if (!prop.value) return null;
                            if (prop.data.region.deleted_at) {
                                return `<del>${prop.value}</del>`;
                            }
                            return prop.value;
                        }
                    },
                    {
                        ...CRUDCellParams,
                        cellRendererParams: {
                            canRead: (params) => {
                                return this.can("read-locality", params.data);
                            },
                            readCb: (id) => {
                                this.$router.push({name: "locality-details", params: {id}});
                            },
                            canEdit: (params) => {
                                return this.can("update-locality", params.data);
                            },
                            editCb: (id) => {
                                this.$router.push({name: "locality-edit", params: {id}});
                            },
                            canDelete: (params) => {
                                return this.can("delete-locality", params.data);
                            },
                            canRestore: (params) => {
                                return this.can("restore-locality", params.data);
                            },
                            deleteCb: (id) => {
                                this.$refs.deleteModal.show(async () => {
                                    try {
                                        await LocalityService.remove(id);
                                        this.$refs.aggridlist.reload();
                                        this.swalSuccess(this.trans("locality.Locality deleted"));
                                    } catch (error) {
                                        let errorMsg = this.getHttpError(error, this.trans("Delete Error"));
                                        this.swalError(errorMsg);
                                    }
                                });
                            },
                            restoreCb: (id) => {
                                this.$refs.restoreModal.show(async () => {
                                    try {
                                        await LocalityService.restore(id);
                                        this.$refs.aggridlist.reload();
                                        this.swalSuccess(this.trans("locality.Locality restored"));
                                    } catch (error) {
                                        let errorMsg = this.getHttpError(error, this.trans("Restore Error"));
                                        this.swalError(errorMsg);
                                    }
                                });
                            }
                        }
                    },
                ],
                frameworkComponents: {
                    IdCellRenderer, CRUDCellRenderer
                },
            }
        }
    }
}
</script>
